import SegmentUtils from 'utils/segment';

/* eslint-disable camelcase */
export default function trackMarketingLanding({pageType, page}) {
    const properties = {
        page_type: pageType,
        page,
    };

    SegmentUtils.page({
        name: 'Marketing Landing',
        properties,
    });
}
